import { css } from '@emotion/react';

import { Colors, Typography } from '@zapier/design-system';
import { urls, useSize } from '@zapier/identity-utils';
import { Button } from '@zapier/marketing-ui';
import { useTranslations } from 'next-intl';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';

const rootStyle = css`
  display: grid;
  gap: 25px;
`;

const textStyle = css`
  ${Typography.Body1}
  color: ${Colors.GrayWarm10};
  text-align: center;
`;

/**
 * Shown for an invalid/expired signup link (ER-680). Sends the user back to
 * login — an unverified account that logs in is re-issued a verification email
 * — rather than minting a fresh token here.
 */
export function VerifySignupExpiredPage() {
  const size = useSize();
  const t = useTranslations('verify-signup-expired');

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={t('title')}
      titlePosition="right"
    >
      <section css={rootStyle}>
        <p css={textStyle}>{t('description')}</p>
        <Button variant="brand" fullWidth={true} href={urls.LOGIN_URL}>
          {t('login-button')}
        </Button>
      </section>
    </AuthLayout>
  );
}
